import Reveal from "../landing/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Operativa() {
  const { t } = useLanguage();

  return (
    <section className="bg-cream py-20 md:py-28" data-testid="operativa-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <p className="kicker" data-testid="operativa-kicker">{t.operativa.kicker}</p>
          <h2 className="mt-5 max-w-4xl font-display text-3xl font-bold leading-tight text-forest-800 md:text-4xl lg:text-5xl">
            {t.operativa.title}
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-forest-800/80">{t.operativa.lead}</p>
        </Reveal>

        <div className="mt-12" data-testid="operativa-dests">
          {t.operativa.dests.map((dest, index) => (
            <Reveal key={dest.name} delay={index * 0.08}>
              <div className="rule grid gap-3 py-7 md:grid-cols-[220px_1fr_280px]" data-testid={`dest-${index}`}>
                <h3 className="font-display text-xl font-bold text-forest-800 md:text-2xl">{dest.name}</h3>
                <p className="text-sm leading-relaxed text-forest-800/75">{dest.desc}</p>
                <p className="text-sm font-semibold leading-relaxed text-forest-700">{dest.benefit}</p>
              </div>
            </Reveal>
          ))}
          <div className="rule" aria-hidden="true" />
        </div>

        <Reveal className="mt-14">
          <h3 className="font-display text-2xl font-bold text-forest-800" data-testid="cambia-title">
            {t.operativa.cambiaTitle}
          </h3>
          <div className="mt-7 grid gap-x-10 gap-y-8 md:grid-cols-2">
            {t.operativa.cambia.map((item) => (
              <div key={item.t} className="rule pt-5">
                <h4 className="font-body text-[11px] font-bold uppercase tracking-[0.2em] text-ember">{item.t}</h4>
                <p className="mt-3 text-sm leading-relaxed text-forest-800/75">{item.d}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-14">
          <div className="border-t-2 border-forest-800 pt-8">
            <blockquote className="max-w-4xl font-display text-xl italic leading-relaxed text-forest-800 md:text-2xl" data-testid="operativa-quote">
              “{t.operativa.quote}”
            </blockquote>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
